var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentNowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9316 0H1.06921C0.573798 0 0.188477 0.385321 0.188477 0.880734V11.1193C0.188477 11.6147 0.573798 12 1.06921 12H15.9316C16.427 12 16.8123 11.6147 16.8123 11.1193V0.880734C16.8123 0.385321 16.427 0 15.9316 0ZM14.2252 9.13762C14.2252 9.3578 14.0325 9.55046 13.8123 9.55046H3.18848C2.96829 9.55046 2.77563 9.3578 2.77563 9.13762V8.20183C2.77563 7.98165 2.96829 7.78899 3.18848 7.78899H13.8123C14.0325 7.78899 14.2252 7.98165 14.2252 8.20183V9.13762ZM15.0233 4.04587C15.0233 4.26606 14.8307 4.45872 14.6105 4.45872H12.8765C12.6564 4.45872 12.4637 4.26606 12.4637 4.04587V2.31193C12.4637 2.09174 12.6564 1.89908 12.8765 1.89908H14.6105C14.8307 1.89908 15.0233 2.09174 15.0233 2.31193V4.04587Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentNowIcon);
export default __webpack_public_path__ + "static/media/payment-now-icon.bdc91dec1a5d9e3199428e6c08d4d9ff.svg";
export { ForwardRef as ReactComponent };